const navItems: QuickSearchItem[] = [
  // Insights
  {
    name: 'Insights',
    icon: 'Chart',
    type: 'Directory',
    route: { name: 'insights-index' }
  },
  // Startups
  {
    name: 'Startups',
    icon: 'Directory',
    type: 'Directory',
    route: { name: 'startups-index' }
  },
  {
    name: 'Operating',
    icon: 'Directory',
    type: 'Startup Directory',
    route: { name: 'startups-index', query: { status: 'operating' } }
  },
  {
    name: 'Acquired',
    icon: 'Directory',
    type: 'Startup Directory',
    route: { name: 'startups-index', query: { status: 'acquired' } }
  },
  {
    name: 'IPO',
    icon: 'Directory',
    type: 'Startup Directory',
    route: { name: 'startups-index', query: { status: 'ipo' } }
  },
  // Investors
  {
    name: 'Investors',
    icon: 'Directory',
    type: 'Investors Directory',
    route: { name: 'investors-index' }
  },
  // Scout
  {
    name: 'Scout',
    icon: 'Scout',
    type: 'Match Portfolio to Investors',
    route: { name: 'investors-index' }
  },
  // Wiki
  {
    name: 'SOSV Wiki',
    icon: 'Book',
    type: 'Information and Policies',
    route: { name: 'wiki-home', params: { wiki: 'sosv' } }
  },
  // Onboarding Dashboard
  {
    name: 'Onboarding',
    icon: 'Directory',
    type: 'New Startup Onboarding',
    route: { name: 'onboarding-index' }
  },
  // News
  {
    name: 'News',
    icon: 'Directory',
    type: 'Directory',
    route: { name: 'news-index' }
  },
  // Programs
  {
    name: 'Programs',
    icon: 'Directory',
    type: 'Directory',
    route: { name: 'programs-index' }
  },
  // Forms
  {
    name: 'Forms',
    icon: 'Directory',
    type: 'Directory',
    route: { name: 'form-tokens' }
  },
  // People
  {
    name: 'People',
    icon: 'Directory',
    type: 'Directory',
    route: { name: 'people-index' }
  },
  {
    name: 'Staff',
    icon: 'Directory',
    type: 'Contact Directory',
    route: { name: 'people-index', query: { contact_type: 'staff' } }
  },
  {
    name: 'Founders',
    icon: 'Directory',
    type: 'Contact Directory',
    route: { name: 'people-index', query: { contact_type: 'founder' } }
  },
  // Chatbots
  {
    name: 'Chatbots',
    icon: 'Robot',
    type: 'AI / LLM Tools',
    route: { name: 'chatbots-index' }
  },
  // Service Logs
  {
    name: 'Service Logs',
    icon: 'List',
    type: 'Service Logs',
    route: { name: 'service-logs' }
  },
]

export function useNavigator() {
  const ui = useUiStore()
  const user = useUserStore()
  const queryModel = ref()
  const algolia = useAlgolia({})
  const queryItems: Ref<QuickSearchItem[]> = ref([])

  // Open navigator on Command-K
  onKeyStroke(['k'], (e) => {
    if (e.metaKey) {
      queryModel.value = ''
      ui.navigator.status ? ui.navigator.close() : ui.navigator.open()
    }
  })

  const favoriteItems = computed((): QuickSearchItem[] => {
    return useCollectionsStore().favorites.models.map((favorite: any) => ({
      name: favorite.name,
      icon: 'Favorite',
      type: `Favorite ${favorite.get('item_type')}`,
      route: favorite.route
    }))
  })

  const roleItems = computed((): QuickSearchItem[] => {
    const items = []
    // Comms Pages
    if (user.hasRole('Communications')) {
      items.push({
        name: 'News Admin',
        icon: 'Admin',
        type: 'Dashboard',
        route: { name: 'news-admin' }
      })
    }
    return items
  })

  const navigatorItems = computed(() => [
    ...favoriteItems.value,
    ...navItems,
    ...roleItems.value,
    ...queryItems.value
  ])

  function queryAlgolia(query: string) {
    algolia.universalSearch(query).then((results) => {
      queryItems.value = results
    })
  }

  function execute(command: QuickSearchItem) {
    ui.navigator.close()
    // Send along if a choice was made
    if (command.route) {
      navigateTo(command.route)
      queryModel.value = null
    }
  }

  return {
    ui,
    queryModel,
    navigatorItems,
    queryAlgolia,
    execute
  }
}
